import { useQuery } from '@tanstack/react-query'

import * as blockchainsServices from '../blockchainsServices'
import { BlockchainCatalogsParams } from '../blockchainsApi'
import { QUERY_KEYS } from '@/constants/queryKeys'

interface QueryOptions {
  enabled?: boolean
}

export const useGetBlockchainsCatalogs = (
  { currency_isin }: BlockchainCatalogsParams,
  queryOptions?: QueryOptions,
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CATALOGS_BLOCKCHAINS, { currency_isin }],
    queryFn: () => {
      return blockchainsServices.getBlockchains({ currency_isin })
    },
    staleTime: 5 * 60 * 1000,
    enabled: queryOptions?.enabled !== false && !!currency_isin,
    onError: () => {},
  })
}
